import { SaleStageStatus } from "../SaleStageStatus.enum";

export const checkSaleStageStatus = (currentRound: number, maxRound: number) => {
  if (currentRound === 0) return SaleStageStatus.InActive;
  else if (currentRound > 0 && currentRound <= maxRound) return SaleStageStatus.Active;
  else return SaleStageStatus.Done;
};
